export default __webpack_public_path__ + "47432785dd6dc9fee03dfa6c0fe98fcd.svg";